import { CheckButtonRow, type CheckButtonRowProps } from "./CheckButtonRow";

const weekdays = "S M T W T F S".split(" ");

export interface WeekdayPickerProps
  extends Omit<CheckButtonRowProps, "buttonLabels"> {}

export const WeekdayPicker = ({ id, ...props }: WeekdayPickerProps) => {
  return <CheckButtonRow id={id} {...props} buttonLabels={weekdays} />;
};
